import axios from "@/plugins/axios";

let url = "/api/v1/auction/halls";

export default {
    get(data) {
        return axios.get(`${url}/${data.hall}`).then((result) => result.data);
    },
};
